module.exports = __webpack_public_path__ + "static/media/5.dadc1ae3.jpg";